import { Alert, Platform, Text, TouchableOpacity, View } from 'react-native';
import { ClubhouseBrandLockup } from './ClubhouseBrandLockup';
import { styles } from '../theme';
import type { LegalDocKey, Translation } from '../types';

export const LEGAL_ENTITY_NAME = 'DIGITAL HERO FZCO';
export const PRODUCT_NAME = 'CLUBHOUSE';

export function getLegalDocs(t: Translation) {
  return [
    {
      key: 'terms' as const,
      label: t.legalTermsLabel,
      title: t.legalTermsTitle,
      body: t.legalTermsBody,
    },
    {
      key: 'privacy' as const,
      label: t.legalPrivacyLabel,
      title: t.legalPrivacyTitle,
      body: t.legalPrivacyBody,
    },
    {
      key: 'cookies' as const,
      label: t.legalCookiesLabel,
      title: t.legalCookiesTitle,
      body: t.legalCookiesBody,
    },
  ];
}

export function LegalFooter({
  t,
  compact = false,
  onOpenDoc,
}: {
  t: Translation;
  compact?: boolean;
  onOpenDoc?: (key: LegalDocKey) => void;
}) {
  const docs = getLegalDocs(t);

  return (
    <View style={[styles.homeLegalFooter, compact && styles.homeLegalFooterCompact]}>
      {!compact && (
        <>
          <View style={styles.footerBrand}>
            <ClubhouseBrandLockup height={48} />
          </View>
          <Text style={styles.homeBrandTagline}>{t.legalTagline}</Text>
        </>
      )}
      <Text style={styles.homeLegalCopy}>© 2026 {LEGAL_ENTITY_NAME}</Text>
      <View style={styles.homeLegalLinks}>
        {docs.map(doc => (
          <TouchableOpacity
            key={doc.key}
            onPress={() => {
              if (onOpenDoc && Platform.OS === 'web') {
                onOpenDoc(doc.key);
                return;
              }
              Alert.alert(doc.title, doc.body);
            }}
          >
            <Text style={styles.homeLegalLink}>{doc.label}</Text>
          </TouchableOpacity>
        ))}
      </View>
    </View>
  );
}
